import { ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncSubject } from 'rxjs';
import * as Highcharts from 'highcharts';
import 'highcharts/modules/drilldown';

export type Point = number | [number, number] | Highcharts.Point;

export class Chart {
  public refSubject: AsyncSubject<Highcharts.Chart> = new AsyncSubject();
  public ref$: Observable<Highcharts.Chart> = this.refSubject.asObservable();
  public ref?: Highcharts.Chart;

  public constructor(public options: Highcharts.Options = { series: [] }) {
  }

  public addPoint(point: Point, serieIndex = 0, redraw = true, shift = false): void {
    this.ref$.subscribe(chart => {
      if (chart.series.length > serieIndex) {
        chart.series[serieIndex].addPoint(point, redraw, shift);
      }
    });
  }

  public addSerie(
    serie: Highcharts.SeriesOptionsType,
    redraw = true,
    animation: boolean | Highcharts.AnimationOptionsObject = false,
  ): void {
    this.ref$.subscribe(chart => {
      chart.addSeries(serie, redraw, animation);
    });
  }

  public removePoint(pointIndex: number, serieIndex = 0): void {
    this.ref$.subscribe(chart => {
      if (chart.series.length > serieIndex && chart.series[serieIndex].data.length > pointIndex) {
        chart.series[serieIndex].removePoint(pointIndex, true);
      }
    });
  }

  public removeSerie(serieIndex: number): void {
    this.ref$.subscribe(chart => {
      if (chart.series.length > serieIndex) {
        chart.series[serieIndex].remove(true);
      }
    });
  }

  public init(el: ElementRef): void {
    Highcharts.chart(el.nativeElement, this.options, chart => {
      this.refSubject.next(chart);
      this.ref = chart;
      this.refSubject.complete();
    });
  }

  public destroy(): void {
    if (this.ref) {
      this.options = this.ref.options;
      this.ref.destroy();
      this.ref = undefined;

      this.refSubject = new AsyncSubject();
      this.ref$ = this.refSubject.asObservable();
    }
  }

  public drillUp(): void {
    this.ref$.subscribe(chart => {
      chart.drillUp();
    });
  }
}
